export default "__VITE_ASSET__DVrpMxfM__"